module.exports = __webpack_public_path__ + "img/one-life-mobile.deda9615.png";